import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-tools-spatula-icon',
  templateUrl: './tools-spatula.component.html'
})
export class ToolsSpatulaComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
